import React from "react";

/**
 * Wiederverwendbare Icon-Card-Komponente im einheitlichen Tailwind-Design.
 *
 * @param {string} icon        – Font-Awesome-Klasse (z.&nbsp;B. "fas fa-users")
 * @param {string} title       – Überschrift der Card
 * @param {string} description – Beschreibungstext
 */
function Card({ icon, title, description }) {
  return (
    <article className="group h-full rounded-2xl border border-slate-200 bg-white p-6 shadow-sm transition-all duration-300 hover:shadow-md motion-safe:hover:-translate-y-0.5 dark:border-slate-700 dark:bg-slate-800 md:p-7">
      <div className="flex flex-col items-center gap-4 text-center">
        <div
          className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-primary/10 transition-transform duration-300 motion-safe:group-hover:scale-105 dark:bg-primary-light/15 md:h-16 md:w-16"
          aria-hidden
        >
          <i
            className={`${icon} text-xl text-primary dark:text-primary-light md:text-2xl`}
          />
        </div>
        <div className="min-w-0 space-y-2">
          <h3 className="text-base font-semibold leading-snug text-slate-900 dark:text-slate-100 md:text-lg">
            {title}
          </h3>
          <p className="text-pretty text-sm leading-relaxed text-slate-600 dark:text-slate-400">
            {description}
          </p>
        </div>
      </div>
    </article>
  );
}

export default Card;
